export default __webpack_public_path__ + "static/media/nfo-navicon.8e8886af.svg";